var map = {
	"./flags/be.svg": 37,
	"./flags/cn.svg": 38,
	"./flags/de.svg": 39,
	"./flags/es.svg": 40,
	"./flags/fr.svg": 41,
	"./flags/gb.svg": 42,
	"./flags/it.svg": 43,
	"./flags/jp.svg": 44,
	"./flags/us.svg": 45,
	"./icons/back.svg": 46,
	"./icons/cart.svg": 47,
	"./icons/close.svg": 48,
	"./icons/error.svg": 49,
	"./icons/facebook.svg": 50,
	"./icons/fleche-up.svg": 51,
	"./icons/fleche.svg": 52,
	"./icons/info.svg": 53,
	"./icons/instagram.svg": 54,
	"./icons/linkedin.svg": 55,
	"./icons/marker.svg": 56,
	"./icons/pinterest.svg": 57,
	"./icons/slider-arrow.svg": 58,
	"./icons/success.svg": 59,
	"./icons/twitter.svg": 60,
	"./icons/weibo.svg": 61,
	"./icons/youtube.svg": 62,
	"./logo-black.png": 63,
	"./logo.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;